/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: "/Login"
  },
  {
    path: "/operationProcess",
    name: "operationProcess",
    component: () => import("@/views/Index/operationProcess.vue"),
    meta: {
      title: "操作流程",
      index: -1,
      needLogin: true,
    }
  },
  {
    path: "/Index",
    name: "Index",
    component: () => import("@/views/Index/Index.vue"),
    meta: {
      title: "阿维森纳健康",
      index: 1,
      needLogin: true,
    }
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Index/search.vue"),
    meta: {
      title: "搜索",
      index: 2,
      needLogin: true,
    }
  },
  {
    path: "/ProductDetails",
    name: "ProductDetails",
    component: () => import("@/views/ProductDetails/ProductDetails.vue"),
    meta: {
      index: 4,
      needLogin: true,
    }
  },
  {
    path: "/FillInInfo",
    name: "FillInInfo",
    component: () => import("@/views/FillInInfo/FillInInfo.vue"),
    meta: {
      needLogin: true,
      title: "填写订单信息",
      index: 6
    }
  },
  {
    path: "/invoice",
    name: "invoice",
    component: () => import("@/views/FillInInfo/invoice/invoice.vue"),
    meta: {
      needLogin: true,
      title: "开具发票",
      index: 7
    }
  },
  {
    path: "/PaymentSuccess",
    name: "PaymentSuccess",
    component: () => import("@/views/PaymentSuccess/PaymentSuccess.vue"),
    meta: {
      needLogin: true,
      index: 8
    }
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("@/views/Login/Login.vue"),
    meta: {
      title: "登录",
      index: 9
    }
  },
  {
    path: "/nurseOperationProcess",
    name: "nurseOperationProcess",
    component: () => import("@/views/NurseOperation/operationProcess.vue"),
    meta: {
      title: "操作流程",
      index: -1
    }
  },
  {
    path: "/nurseLogin",
    name: "nurseLogin",
    component: () => import("@/views/NurseOperation/nurseLogin.vue"),
    meta: {
      title: "护士登录",
      index: 1
    }
  },
  {
    path: "/nurseSweepCodeBinding",
    name: "nurseSweepCodeBinding",
    component: () => import("@/views/NurseOperation/sweepCodeBinding.vue"),
    meta: {
      index: 2,
      title: "扫码绑定试管"
    }
  },
  {
    path: "/nurseManualBinding",
    name: "nurseManualBinding",
    component: () => import("@/views/NurseOperation/manualBinding.vue"),
    meta: {
      index: 3,
      title: "手动绑定"
    }
  },
  {
    path: "/barCodeScanningGunBinding",
    name: "barCodeScanningGunBinding",
    component: () => import("@/views/NurseOperation/barCodeScanningGunBinding.vue"),
    meta: {
      index: 3,
      title: "扫码枪绑定"
    }
  },

  {
    path: "/nurseBindingUserInfoList",
    name: "nurseBindingUserInfoList",
    component: () => import("@/views/NurseOperation/bindingUserInfoList.vue"),
    meta: {
      index: 6,
      title: "绑定多个"
    }
  },
  {
    path: "/MyTesting",
    name: "MyTesting",
    component: () => import("@/views/MyTesting/MyTesting.vue"),
    meta: {
      needLogin: true,
      title: "我的报告",
      index: 2
    }
  },
  {
    path: "/OrderList",
    name: "OrderList",
    component: () => import("@/views/OrderList/index.vue"),
    meta: {
      needLogin: true,
      title: "我的订单",
      index: 2
    }
  },
  {
    path: "/SeePresentation",
    name: "SeePresentation",
    component: () => import("@/views/MyTesting/SeePresentation/SeePresentation.vue"),
    meta: {
      title: "查看报告",
      index: 3
    }
  },

  {
    path: "/sweepCodeBinding",
    name: "sweepCodeBinding",
    component: () => import("@/views/bindingUserInfo/sweepCodeBinding.vue"),
    meta: {
      index: 4,
      title: "扫码绑定试管"
    }
  },
  {
    path: "/manualBinding",
    name: "manualBinding",
    component: () => import("@/views/bindingUserInfo/manualBinding.vue"),
    meta: {
      index: 5,
      title: "手动绑定"
    }
  },
  {
    path: "/bindingUserInfoList",
    name: "bindingUserInfoList",
    component: () => import("@/views/bindingUserInfo/bindingUserInfoList.vue"),
    meta: {
      index: 6,
      needLogin: true,
      title: "绑定多个"
    }
  },
  {
    path: "/bindingProductList",
    name: "bindingProductList",
    component: () => import("@/views/bindingUserInfo/bindingProductList.vue"),
    meta: {
      index: 6,
      title: "绑定产品"
    }
  },
  {
    path: "/searchProduct",
    name: "searchProduct",
    component: () => import("@/views/bindingUserInfo/searchProduct.vue"),
    meta: {
      index: 7,
      title: "选择产品"
    }
  },
  {
    path: "/ShoppingCart",
    name: "ShoppingCart",
    component: () => import("@/views/ShoppingCart/Index.vue"),
    meta: {
      title: "已选项",
      needLogin: true,
      index: 5
    }
  },
  {
    path: "*",
    name: "error",
    component: () => import("@/views/Error/error404.vue"),
    meta: {
      index: 100
    }
  }
  ]
});